const ICONOS = {
  crear: '＋',
  editar: '✎',
  guardar: '✓',
  cancelar: '↩',
  eliminar: '✖',
  deshabilitar: '⊘',
  restablecer: '↻',
  cerrar: '■',
  abrir: '▶',
  volver: '←',
  // Issue #74: icono de la sección ALERTA (antes «Panel»), en rojo vía `.icon-alerta`. U+26A0 + VS15
  // (presentación de texto) para que tome el color del CSS en vez de pintarse como emoji amarillo.
  alerta: '\u26A0\uFE0E',
} as const

export type IconoAccion = keyof typeof ICONOS

// Decorativo: el texto del botón sigue siendo su nombre accesible.
export function Icon({ name, className }: { name: IconoAccion; className?: string }) {
  return (
    <span aria-hidden="true" className={className} style={{ marginRight: 6 }}>
      {ICONOS[name]}
    </span>
  )
}
